@use "~theme/breakpoints";
@use "~theme/typographyV2" as typography;

.contentLeft {
    float:left;
    width: 55%;
    padding-left: 10px;
    padding-top: 10px;
}

.contentRight {
    float:right;
    width:45%;
    text-align: right;
    padding-right: 10px;
    padding-top: 10px;
}

.footerPhoneLink {
    white-space: nowrap;
    color: var(--blue-01);
    font-family: typography.$font-mont;
    font-weight: 400;
    font-style: normal;
    font-size: 12px;
    line-height: 16.8px;
    letter-spacing: 0.24px;
    text-align: right;
    vertical-align: middle;
    text-decoration: none;
    text-decoration-skip-ink: auto;
    display: inline-flex;
    align-items: center;
    gap: 1px;
}

.phoneNumberText {
    display: inline-block;
    border-bottom: 1px solid currentColor;
    padding-bottom: 2px;
    line-height: 1;
}

.officeName {
    font-size: 16px;
    color: var(--blue-01);
    font-weight: 600;
    text-decoration-line: underline;
    text-decoration-thickness: 1px;
    text-underline-offset: 2px;
    font-family: typography.$font-mont;
    @include breakpoints.desktop {
        font-size: 16px;
    }
    @include breakpoints.desktop-medium {
        font-size: 16px;
    }
    @include breakpoints.desktop-large {
        font-family: typography.$font-mont;
        font-weight: 600;
        font-style: normal;
        font-size: 16px;
        line-height: 120%;
        letter-spacing: 0px;
        vertical-align: middle;
        text-decoration: underline;
        text-decoration-style: solid;
        text-decoration-offset: 0px;
        text-decoration-thickness: 1px;
        text-decoration-skip-ink: auto;
        color: var(--blue-01);

    }
}

.officeAddress {
    color: var(--blue-01);
    font-size: 14px;
    font-weight: 400;
    font-family: typography.$font-mont;
    @include breakpoints.desktop {
        font-size: 12px;
    }
    @include breakpoints.desktop-medium {
        font-size: 13px;
    }
    @include breakpoints.desktop-large {
        font-family: typography.$font-mont;
        font-weight: 400;
        font-style: Regular;
        font-size: 14px;
        line-height: 140%;
        letter-spacing: 0px;
        vertical-align: middle;
        color: var(--blue-01);
    }
}

.officePhone {
    color: var(--blue-01);
    font-size: 12px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0.02em;
    padding-top: 2px;
    text-decoration: underline;
    text-underline-offset: 1px;
}

.icon {
    width: 16px;
    @include breakpoints.desktop {
        width: auto;
    }
}

.medicaid {
    color: var(--blue-01);
    font-size: 10px;
    font-weight: 400;
}

.timings {
    color: var(--blue-01);    
    font-size: 14px;
    font-weight: 600;
    line-height: 140%;
    letter-spacing: 0.02em;
    @include breakpoints.desktop {
        font-size: 12px;
        font-weight: 400;
    }
}

.nearbyContent {
    cursor: pointer;
    display: block;
    overflow: auto;
    box-shadow: none;
    margin: 0;
    padding-bottom: 0;
    @include breakpoints.desktop {
        padding-bottom: 0px;
        margin: 0px;
        box-shadow: none;
    }

    &:first-child .contentHeader {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    &:last-child {
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
    }
}

.contentHeader {
    background: var(--highlight-blue-05);
    border-radius: 0;
    height: 40px;
    align-items: center;
    display: flex;
    text-align: center;
    img {
        right: 6%;
        padding: 10px 8px;
        @include breakpoints.desktop {
            padding: 10px 8px;
        }
    }
    .miles {
        font-family: typography.$font-mont;
        font-weight: 400;
        font-style: normal;
        font-size: 13px;
        line-height: 100%;
        letter-spacing: 0%;
        vertical-align: middle;
        text-transform: lowercase;
        align-items: center;
        color: var(--blue-01);
        width: 30%;
        float: left;
        text-align: left;
        padding-left: 12px;
    }
    .examDetails {
        font-weight: 400;
        font-size: 13px;
        line-height: 100%;
        display: block;
        align-items: center;
        text-align: right;
        color: var(--blue-01);
        width: 70%;
        letter-spacing: -0.02em;
        margin-right: 10px;
        @include breakpoints.desktop {
            font-weight: 400;
        }
    }
}
.officeAddressContainer {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    min-height: 92px;
    padding: 8px 12px 14px;
}
.totalSlots {
    font-family: typography.$font-mont;
    font-weight: 400;
    border: 1px solid var(--highlight-blue-04);
    padding: 3px 5px;
    border-radius: 25px;
    background-color: var(--highlight-blue-04);
    float: right;
    img {
        width: 15px;
        height: 15px;
        padding: 0px;
        margin: 0px;
    }
}

.slotsContainer {
    padding: 10px;
    display: flex;
}

.slotAvailable {
    font-family: typography.$font-mont;
    font-weight: 400;
    border: 1px solid black;
    border-radius: 5px;
    padding: 5px;
    width: 33%;
    float: right;
    margin-right: 10px;
    margin-bottom: 10px;
    font-size: 12px;
    text-align: center;
    @include breakpoints.desktop {
        width: 28%;   
    }
}

.slotIcon {
    width: 15px;
    height: 15px;
    padding: 0px;
    margin: 0px;
}

.morningSlotIcon {
    margin-top: -5px;
}
